export default __webpack_public_path__ + "static/media/cottage-pie.0a0f2cd2.png";